export const SCENE_ANIMATION_6 = {
    "items": [
        {
            "time": 0.019999999552965165,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.518,0.000,0.855",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.495,0.000,1.553,0.000,-0.665,0.000,0.747",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.667,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.041,0.856,-0.060,0.512"
            ]
        },
        {
            "time": 0.029999999329447748,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.518,0.000,0.855",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.495,0.000,1.553,0.000,-0.665,0.000,0.747",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.667,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.041,0.856,-0.060,0.512"
            ]
        },
        {
            "time": 0.03999999910593033,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.519,0.000,0.855",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.495,0.000,1.553,0.000,-0.665,0.000,0.747",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.667,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.041,0.856,-0.060,0.512"
            ]
        },
        {
            "time": 0.06199999898672104,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.521,0.000,0.854",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.495,0.000,1.554,0.000,-0.665,0.000,0.746",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.668,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.041,0.856,-0.060,0.512"
            ]
        },
        {
            "time": 0.07900000363588333,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.526,0.000,0.850",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.495,0.000,1.555,0.000,-0.666,0.000,0.746",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.669,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.041,0.856,-0.059,0.513"
            ]
        },
        {
            "time": 0.0820000022649765,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.531,0.000,0.847",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.495,0.000,1.556,0.000,-0.666,0.000,0.746",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.670,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.041,0.855,-0.059,0.513"
            ]
        },
        {
            "time": 0.10000000149011612,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.532,0.000,0.847",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.495,0.000,1.557,0.000,-0.666,0.000,0.746",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.671,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.041,0.855,-0.059,0.513"
            ]
        },
        {
            "time": 0.10999999940395355,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.539,0.000,0.843",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.496,0.000,1.558,0.000,-0.666,0.000,0.746",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.672,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.041,0.855,-0.059,0.514"
            ]
        },
        {
            "time": 0.12099999934434891,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.543,0.000,0.840",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.496,0.000,1.559,0.000,-0.667,0.000,0.745",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.673,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.041,0.854,-0.059,0.515"
            ]
        },
        {
            "time": 0.13199999928474427,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.548,0.000,0.837",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.496,0.000,1.560,0.000,-0.667,0.000,0.745",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.675,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.041,0.854,-0.059,0.515"
            ]
        },
        {
            "time": 0.1459999978542328,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.553,0.000,0.833",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.496,0.000,1.562,0.000,-0.667,0.000,0.745",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.676,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.041,0.854,-0.059,0.516"
            ]
        },
        {
            "time": 0.16099999845027924,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.559,0.000,0.829",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.496,0.000,1.564,0.000,-0.668,0.000,0.744",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.678,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.041,0.853,-0.059,0.517"
            ]
        },
        {
            "time": 0.16899999976158143,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.567,0.000,0.824",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.496,0.000,1.566,0.000,-0.668,0.000,0.744",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.680,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.041,0.852,-0.059,0.518"
            ]
        },
        {
            "time": 0.18000000715255738,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.571,0.000,0.821",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.497,0.000,1.567,0.000,-0.668,0.000,0.744",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.681,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.041,0.852,-0.059,0.518"
            ]
        },
        {
            "time": 0.19200000166893006,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.577,0.000,0.817",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.497,0.000,1.569,0.000,-0.669,0.000,0.743",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.683,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.041,0.852,-0.059,0.519"
            ]
        },
        {
            "time": 0.20499999821186067,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.584,0.000,0.812",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.497,0.000,1.571,0.000,-0.669,0.000,0.743",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.685,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.041,0.851,-0.059,0.520"
            ]
        },
        {
            "time": 0.21699999272823335,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.591,0.000,0.807",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.497,0.000,1.573,0.000,-0.670,0.000,0.742",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.687,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.041,0.850,-0.059,0.521"
            ]
        },
        {
            "time": 0.2290000021457672,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.598,0.000,0.802",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.498,0.000,1.575,0.000,-0.670,0.000,0.742",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.689,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.041,0.850,-0.059,0.522"
            ]
        },
        {
            "time": 0.23999999463558198,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.605,0.000,0.797",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.498,0.000,1.577,0.000,-0.671,0.000,0.742",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.692,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.042,0.849,-0.059,0.524"
            ]
        },
        {
            "time": 0.2549999952316284,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.611,0.000,0.792",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.498,0.000,1.580,0.000,-0.671,0.000,0.741",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.694,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.042,0.848,-0.059,0.525"
            ]
        },
        {
            "time": 0.2669999897480011,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.619,0.000,0.785",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.498,0.000,1.583,0.000,-0.672,0.000,0.740",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.697,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.042,0.847,-0.059,0.526"
            ]
        },
        {
            "time": 0.28200000524520876,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.626,0.000,0.780",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.499,0.000,1.585,0.000,-0.673,0.000,0.740",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.700,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.042,0.846,-0.059,0.528"
            ]
        },
        {
            "time": 0.2939999997615814,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.635,0.000,0.773",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.499,0.000,1.589,0.000,-0.674,0.000,0.739",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.703,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.042,0.845,-0.059,0.529"
            ]
        },
        {
            "time": 0.30799999833106997,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.641,0.000,0.767",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.499,0.000,1.591,0.000,-0.674,0.000,0.739",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.706,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.042,0.845,-0.059,0.531"
            ]
        },
        {
            "time": 0.32100000977516177,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.649,0.000,0.761",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.500,0.000,1.595,0.000,-0.675,0.000,0.738",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.709,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.042,0.844,-0.059,0.532"
            ]
        },
        {
            "time": 0.33500000834465029,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.656,0.000,0.755",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.500,0.000,1.598,0.000,-0.676,0.000,0.737",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.712,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.042,0.842,-0.059,0.534"
            ]
        },
        {
            "time": 0.3499999940395355,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.662,0.000,0.749",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.500,0.000,1.601,0.000,-0.676,0.000,0.737",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.716,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.042,0.841,-0.059,0.535"
            ]
        },
        {
            "time": 0.36500000953674319,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.669,0.000,0.743",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.501,0.000,1.605,0.000,-0.677,0.000,0.736",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.719,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.043,0.840,-0.058,0.537"
            ]
        },
        {
            "time": 0.38100001215934756,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.676,0.000,0.737",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.501,0.000,1.609,0.000,-0.678,0.000,0.735",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.723,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.043,0.839,-0.058,0.539"
            ]
        },
        {
            "time": 0.38999998569488528,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.682,0.000,0.731",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.502,0.000,1.613,0.000,-0.679,0.000,0.734",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.727,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.043,0.838,-0.058,0.541"
            ]
        },
        {
            "time": 0.4050000011920929,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.686,0.000,0.728",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.502,0.000,1.615,0.000,-0.680,0.000,0.734",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.730,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.043,0.837,-0.058,0.543"
            ]
        },
        {
            "time": 0.4189999997615814,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.691,0.000,0.723",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.503,0.000,1.619,0.000,-0.681,0.000,0.733",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.734,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.043,0.836,-0.058,0.545"
            ]
        },
        {
            "time": 0.4320000112056732,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.695,0.000,0.719",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.503,0.000,1.623,0.000,-0.681,0.000,0.732",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.738,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.043,0.834,-0.058,0.546"
            ]
        },
        {
            "time": 0.44600000977516177,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.698,0.000,0.716",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.503,0.000,1.626,0.000,-0.682,0.000,0.731",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.741,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.043,0.833,-0.058,0.548"
            ]
        },
        {
            "time": 0.4580000042915344,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.702,0.000,0.713",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.504,0.000,1.630,0.000,-0.683,0.000,0.730",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.745,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.043,0.832,-0.058,0.550"
            ]
        },
        {
            "time": 0.47600001096725466,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.704,0.000,0.711",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.504,0.000,1.633,0.000,-0.684,0.000,0.730",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.748,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.044,0.831,-0.058,0.552"
            ]
        },
        {
            "time": 0.4880000054836273,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.706,0.000,0.708",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.505,0.000,1.638,0.000,-0.685,0.000,0.729",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.753,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.044,0.829,-0.058,0.554"
            ]
        },
        {
            "time": 0.49900001287460329,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.505,0.000,1.642,0.000,-0.686,0.000,0.728",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.757,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.044,0.828,-0.058,0.556"
            ]
        },
        {
            "time": 0.5120000243186951,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.505,0.000,1.645,0.000,-0.686,0.000,0.727",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.760,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.044,0.827,-0.058,0.558"
            ]
        },
        {
            "time": 0.5260000228881836,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.506,0.000,1.648,0.000,-0.687,0.000,0.726",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.763,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.044,0.826,-0.057,0.560"
            ]
        },
        {
            "time": 0.5400000214576721,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.506,0.000,1.652,0.000,-0.688,0.000,0.726",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.767,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.044,0.824,-0.057,0.562"
            ]
        },
        {
            "time": 0.5529999732971191,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.507,0.000,1.656,0.000,-0.689,0.000,0.725",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.771,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.044,0.823,-0.057,0.564"
            ]
        },
        {
            "time": 0.5669999718666077,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.507,0.000,1.660,0.000,-0.690,0.000,0.724",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.775,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.045,0.822,-0.057,0.565"
            ]
        },
        {
            "time": 0.5830000042915344,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.508,0.000,1.663,0.000,-0.691,0.000,0.723",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.779,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.045,0.820,-0.057,0.567"
            ]
        },
        {
            "time": 0.5950000286102295,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.508,0.000,1.668,0.000,-0.692,0.000,0.722",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.783,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.045,0.819,-0.057,0.570"
            ]
        },
        {
            "time": 0.6079999804496765,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.508,0.000,1.671,0.000,-0.692,0.000,0.722",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.786,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.045,0.817,-0.057,0.571"
            ]
        },
        {
            "time": 0.621999979019165,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.509,0.000,1.674,0.000,-0.693,0.000,0.721",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.790,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.045,0.816,-0.057,0.573"
            ]
        },
        {
            "time": 0.6349999904632568,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.509,0.000,1.678,0.000,-0.694,0.000,0.720",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.793,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.045,0.815,-0.057,0.575"
            ]
        },
        {
            "time": 0.6499999761581421,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.510,0.000,1.681,0.000,-0.695,0.000,0.719",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.797,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.046,0.813,-0.057,0.577"
            ]
        },
        {
            "time": 0.6639999747276306,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.510,0.000,1.685,0.000,-0.696,0.000,0.718",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.801,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.046,0.812,-0.057,0.579"
            ]
        },
        {
            "time": 0.6779999732971191,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.510,0.000,1.689,0.000,-0.696,0.000,0.718",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.804,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.046,0.811,-0.056,0.581"
            ]
        },
        {
            "time": 0.6919999718666077,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.511,0.000,1.692,0.000,-0.697,0.000,0.717",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.808,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.046,0.809,-0.056,0.583"
            ]
        },
        {
            "time": 0.7080000042915344,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.511,0.000,1.695,0.000,-0.698,0.000,0.716",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.811,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.046,0.808,-0.056,0.585"
            ]
        },
        {
            "time": 0.718999981880188,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.512,0.000,1.699,0.000,-0.699,0.000,0.715",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.815,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.046,0.806,-0.056,0.587"
            ]
        },
        {
            "time": 0.7319999933242798,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.512,0.000,1.702,0.000,-0.699,0.000,0.715",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.817,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.046,0.805,-0.056,0.588"
            ]
        },
        {
            "time": 0.7440000176429749,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.512,0.000,1.704,0.000,-0.700,0.000,0.714",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.820,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.046,0.804,-0.056,0.590"
            ]
        },
        {
            "time": 0.7570000290870667,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.513,0.000,1.707,0.000,-0.700,0.000,0.714",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.823,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.047,0.803,-0.056,0.591"
            ]
        },
        {
            "time": 0.7730000019073486,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.513,0.000,1.710,0.000,-0.701,0.000,0.713",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.825,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.047,0.802,-0.056,0.593"
            ]
        },
        {
            "time": 0.7870000004768372,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.513,0.000,1.713,0.000,-0.702,0.000,0.712",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.829,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.047,0.801,-0.056,0.595"
            ]
        },
        {
            "time": 0.8029999732971191,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.514,0.000,1.715,0.000,-0.702,0.000,0.712",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.831,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.047,0.799,-0.056,0.596"
            ]
        },
        {
            "time": 0.8169999718666077,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.514,0.000,1.718,0.000,-0.703,0.000,0.711",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.834,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.047,0.798,-0.056,0.598"
            ]
        },
        {
            "time": 0.8259999752044678,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.514,0.000,1.721,0.000,-0.703,0.000,0.711",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.837,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.047,0.797,-0.056,0.600"
            ]
        },
        {
            "time": 0.8399999737739563,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.514,0.000,1.722,0.000,-0.704,0.000,0.710",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.838,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.047,0.796,-0.056,0.601"
            ]
        },
        {
            "time": 0.8550000190734863,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.515,0.000,1.724,0.000,-0.704,0.000,0.710",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.840,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.047,0.795,-0.055,0.602"
            ]
        },
        {
            "time": 0.8679999709129334,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.515,0.000,1.727,0.000,-0.705,0.000,0.709",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.842,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.048,0.794,-0.055,0.604"
            ]
        },
        {
            "time": 0.8820000290870667,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.515,0.000,1.728,0.000,-0.705,0.000,0.709",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.844,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.048,0.793,-0.055,0.605"
            ]
        },
        {
            "time": 0.8939999938011169,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.515,0.000,1.730,0.000,-0.706,0.000,0.709",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.846,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.048,0.792,-0.055,0.606"
            ]
        },
        {
            "time": 0.9100000262260437,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.515,0.000,1.731,0.000,-0.706,0.000,0.708",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.847,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.048,0.791,-0.055,0.607"
            ]
        },
        {
            "time": 0.921999990940094,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.733,0.000,-0.706,0.000,0.708",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.849,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.048,0.790,-0.055,0.608"
            ]
        },
        {
            "time": 0.9369999766349793,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.734,0.000,-0.706,0.000,0.708",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.850,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.048,0.790,-0.055,0.609"
            ]
        },
        {
            "time": 0.9490000009536743,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.735,0.000,-0.707,0.000,0.708",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.851,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.048,0.789,-0.055,0.610"
            ]
        },
        {
            "time": 0.9620000123977661,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.736,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.852,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.048,0.788,-0.055,0.611"
            ]
        },
        {
            "time": 0.9760000109672546,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.736,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.852,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.048,0.787,-0.055,0.612"
            ]
        },
        {
            "time": 0.9919999837875366,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.737,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.853,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.048,0.787,-0.055,0.613"
            ]
        },
        {
            "time": 1.003999948501587,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.737,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.853,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.048,0.786,-0.055,0.614"
            ]
        },
        {
            "time": 1.0199999809265137,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.737,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.853,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.048,0.786,-0.055,0.614"
            ]
        },
        {
            "time": 1.031999945640564,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.874,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.737,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.853,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.049,0.785,-0.055,0.615"
            ]
        },
        {
            "time": 1.0460000038146973,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.873,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.737,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.853,0.000,-0.707,0.000,0.707",
                "observationCamera,9.718,0.395,2.033,0.049,0.785,-0.055,0.615"
            ]
        },
        {
            "time": 1.059000015258789,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.872,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.737,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.852,0.000,-0.707,0.000,0.707",
                "observationCamera,9.719,0.395,2.033,0.049,0.784,-0.055,0.616"
            ]
        },
        {
            "time": 1.0740000009536744,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.871,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.737,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.851,0.000,-0.707,0.000,0.707",
                "observationCamera,9.720,0.395,2.032,0.049,0.784,-0.055,0.617"
            ]
        },
        {
            "time": 1.0850000381469727,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.869,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.736,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.851,0.000,-0.707,0.000,0.707",
                "observationCamera,9.721,0.395,2.032,0.049,0.783,-0.055,0.617"
            ]
        },
        {
            "time": 1.1009999513626099,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.868,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.736,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.850,0.000,-0.707,0.000,0.707",
                "observationCamera,9.721,0.395,2.032,0.049,0.783,-0.055,0.618"
            ]
        },
        {
            "time": 1.1130000352859498,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.866,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.736,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.848,0.000,-0.707,0.000,0.707",
                "observationCamera,9.723,0.395,2.031,0.049,0.782,-0.055,0.618"
            ]
        },
        {
            "time": 1.128999948501587,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.864,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.735,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.847,0.000,-0.707,0.000,0.707",
                "observationCamera,9.724,0.395,2.031,0.049,0.782,-0.055,0.619"
            ]
        },
        {
            "time": 1.1449999809265137,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.861,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.735,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.846,0.000,-0.707,0.000,0.707",
                "observationCamera,9.726,0.395,2.030,0.049,0.781,-0.055,0.620"
            ]
        },
        {
            "time": 1.156000018119812,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.857,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.734,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.844,0.000,-0.707,0.000,0.707",
                "observationCamera,9.728,0.395,2.030,0.049,0.781,-0.055,0.620"
            ]
        },
        {
            "time": 1.1679999828338624,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.855,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.734,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.843,0.000,-0.707,0.000,0.707",
                "observationCamera,9.729,0.395,2.029,0.049,0.781,-0.055,0.621"
            ]
        },
        {
            "time": 1.1829999685287476,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.852,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.734,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.841,0.000,-0.707,0.000,0.707",
                "observationCamera,9.731,0.394,2.029,0.049,0.780,-0.055,0.621"
            ]
        },
        {
            "time": 1.1970000267028809,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.848,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.733,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.839,0.000,-0.707,0.000,0.707",
                "observationCamera,9.734,0.394,2.028,0.049,0.780,-0.055,0.622"
            ]
        },
        {
            "time": 1.2109999656677247,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.844,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.732,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.837,0.000,-0.707,0.000,0.707",
                "observationCamera,9.736,0.394,2.027,0.050,0.779,-0.055,0.622"
            ]
        },
        {
            "time": 1.2239999771118165,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.841,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.732,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.835,0.000,-0.707,0.000,0.707",
                "observationCamera,9.739,0.394,2.027,0.050,0.779,-0.055,0.623"
            ]
        },
        {
            "time": 1.2400000095367432,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.837,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.731,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.833,0.000,-0.707,0.000,0.707",
                "observationCamera,9.741,0.394,2.026,0.050,0.779,-0.055,0.623"
            ]
        },
        {
            "time": 1.2549999952316285,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.832,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.730,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.830,0.000,-0.707,0.000,0.707",
                "observationCamera,9.744,0.394,2.025,0.050,0.778,-0.055,0.624"
            ]
        },
        {
            "time": 1.2640000581741334,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.827,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.729,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.827,0.000,-0.707,0.000,0.707",
                "observationCamera,9.748,0.394,2.024,0.050,0.778,-0.055,0.624"
            ]
        },
        {
            "time": 1.2790000438690186,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.824,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.729,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.826,0.000,-0.707,0.000,0.707",
                "observationCamera,9.750,0.394,2.023,0.050,0.777,-0.055,0.625"
            ]
        },
        {
            "time": 1.2910000085830689,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.818,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.728,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.823,0.000,-0.707,0.000,0.707",
                "observationCamera,9.753,0.394,2.022,0.050,0.777,-0.055,0.625"
            ]
        },
        {
            "time": 1.305999994277954,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.814,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.727,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.821,0.000,-0.707,0.000,0.707",
                "observationCamera,9.756,0.393,2.021,0.050,0.777,-0.056,0.625"
            ]
        },
        {
            "time": 1.3179999589920045,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.809,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.726,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.818,0.000,-0.707,0.000,0.707",
                "observationCamera,9.760,0.393,2.020,0.050,0.776,-0.056,0.626"
            ]
        },
        {
            "time": 1.3320000171661378,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.804,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.725,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.815,0.000,-0.707,0.000,0.707",
                "observationCamera,9.763,0.393,2.019,0.051,0.776,-0.056,0.626"
            ]
        },
        {
            "time": 1.3480000495910645,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.799,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.725,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.812,0.000,-0.707,0.000,0.707",
                "observationCamera,9.767,0.393,2.018,0.051,0.776,-0.056,0.627"
            ]
        },
        {
            "time": 1.3639999628067017,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.792,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.723,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.809,0.000,-0.707,0.000,0.707",
                "observationCamera,9.772,0.393,2.017,0.051,0.775,-0.056,0.627"
            ]
        },
        {
            "time": 1.3739999532699586,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.786,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.722,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.805,0.000,-0.707,0.000,0.707",
                "observationCamera,9.776,0.393,2.015,0.051,0.775,-0.056,0.628"
            ]
        },
        {
            "time": 1.3869999647140504,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.782,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.721,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.803,0.000,-0.707,0.000,0.707",
                "observationCamera,9.779,0.392,2.014,0.051,0.775,-0.056,0.628"
            ]
        },
        {
            "time": 1.4019999504089356,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.777,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.720,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.800,0.000,-0.707,0.000,0.707",
                "observationCamera,9.783,0.392,2.013,0.051,0.774,-0.056,0.628"
            ]
        },
        {
            "time": 1.4140000343322755,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.770,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.719,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.797,0.000,-0.707,0.000,0.707",
                "observationCamera,9.788,0.392,2.012,0.051,0.774,-0.056,0.629"
            ]
        },
        {
            "time": 1.4290000200271607,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.765,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.718,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.794,0.000,-0.707,0.000,0.707",
                "observationCamera,9.792,0.392,2.010,0.051,0.774,-0.056,0.629"
            ]
        },
        {
            "time": 1.4429999589920045,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.759,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.717,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.791,0.000,-0.707,0.000,0.707",
                "observationCamera,9.797,0.392,2.009,0.052,0.773,-0.056,0.630"
            ]
        },
        {
            "time": 1.4570000171661378,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.753,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.716,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.787,0.000,-0.707,0.000,0.707",
                "observationCamera,9.802,0.391,2.007,0.052,0.773,-0.057,0.630"
            ]
        },
        {
            "time": 1.468999981880188,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.747,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.714,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.784,0.000,-0.707,0.000,0.707",
                "observationCamera,9.807,0.391,2.006,0.052,0.773,-0.057,0.630"
            ]
        },
        {
            "time": 1.4839999675750733,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.742,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.713,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.781,0.000,-0.707,0.000,0.707",
                "observationCamera,9.811,0.391,2.005,0.052,0.772,-0.057,0.631"
            ]
        },
        {
            "time": 1.4950000047683716,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.735,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.712,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.778,0.000,-0.707,0.000,0.707",
                "observationCamera,9.817,0.391,2.003,0.052,0.772,-0.057,0.631"
            ]
        },
        {
            "time": 1.5110000371932984,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.730,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.711,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.775,0.000,-0.707,0.000,0.707",
                "observationCamera,9.821,0.391,2.002,0.052,0.772,-0.057,0.631"
            ]
        },
        {
            "time": 1.5240000486373902,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.723,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.709,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.771,0.000,-0.707,0.000,0.707",
                "observationCamera,9.827,0.390,2.000,0.052,0.771,-0.057,0.632"
            ]
        },
        {
            "time": 1.5360000133514405,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.718,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.708,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.768,0.000,-0.707,0.000,0.707",
                "observationCamera,9.832,0.390,1.998,0.052,0.771,-0.057,0.632"
            ]
        },
        {
            "time": 1.5499999523162842,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.712,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.707,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.765,0.000,-0.707,0.000,0.707",
                "observationCamera,9.836,0.390,1.997,0.053,0.771,-0.057,0.632"
            ]
        },
        {
            "time": 1.565999984741211,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.706,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.706,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.762,0.000,-0.707,0.000,0.707",
                "observationCamera,9.842,0.390,1.995,0.053,0.770,-0.057,0.633"
            ]
        },
        {
            "time": 1.5809999704360963,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.699,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.704,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.759,0.000,-0.707,0.000,0.707",
                "observationCamera,9.848,0.390,1.993,0.053,0.770,-0.058,0.633"
            ]
        },
        {
            "time": 1.590999960899353,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.693,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.702,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.755,0.000,-0.707,0.000,0.707",
                "observationCamera,9.855,0.389,1.991,0.053,0.770,-0.058,0.633"
            ]
        },
        {
            "time": 1.6059999465942383,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.689,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.701,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.753,0.000,-0.707,0.000,0.707",
                "observationCamera,9.859,0.389,1.990,0.053,0.770,-0.058,0.634"
            ]
        },
        {
            "time": 1.6200000047683716,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.682,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.700,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.749,0.000,-0.707,0.000,0.707",
                "observationCamera,9.865,0.389,1.988,0.053,0.769,-0.058,0.634"
            ]
        },
        {
            "time": 1.63100004196167,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.677,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.698,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.746,0.000,-0.707,0.000,0.707",
                "observationCamera,9.871,0.389,1.986,0.053,0.769,-0.058,0.634"
            ]
        },
        {
            "time": 1.6449999809265137,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.672,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.697,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.744,0.000,-0.707,0.000,0.707",
                "observationCamera,9.876,0.388,1.985,0.054,0.769,-0.058,0.635"
            ]
        },
        {
            "time": 1.6579999923706055,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.666,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.695,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.741,0.000,-0.707,0.000,0.707",
                "observationCamera,9.882,0.388,1.983,0.054,0.769,-0.058,0.635"
            ]
        },
        {
            "time": 1.6740000247955323,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.661,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.694,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.738,0.000,-0.707,0.000,0.707",
                "observationCamera,9.888,0.388,1.981,0.054,0.768,-0.058,0.635"
            ]
        },
        {
            "time": 1.687999963760376,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.655,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.692,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.734,0.000,-0.707,0.000,0.707",
                "observationCamera,9.895,0.388,1.979,0.054,0.768,-0.059,0.635"
            ]
        },
        {
            "time": 1.6990000009536744,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.649,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.690,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.732,0.000,-0.707,0.000,0.707",
                "observationCamera,9.901,0.387,1.977,0.054,0.768,-0.059,0.636"
            ]
        },
        {
            "time": 1.7139999866485596,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.645,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.689,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.729,0.000,-0.707,0.000,0.707",
                "observationCamera,9.906,0.387,1.975,0.054,0.768,-0.059,0.636"
            ]
        },
        {
            "time": 1.7259999513626099,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.640,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.687,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.726,0.000,-0.707,0.000,0.707",
                "observationCamera,9.913,0.387,1.973,0.055,0.767,-0.059,0.636"
            ]
        },
        {
            "time": 1.7410000562667847,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.636,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.686,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.724,0.000,-0.707,0.000,0.707",
                "observationCamera,9.919,0.387,1.971,0.055,0.767,-0.059,0.636"
            ]
        },
        {
            "time": 1.753000020980835,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.630,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.684,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.721,0.000,-0.707,0.000,0.707",
                "observationCamera,9.926,0.386,1.969,0.055,0.767,-0.059,0.637"
            ]
        },
        {
            "time": 1.7690000534057618,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.627,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.683,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.719,0.000,-0.707,0.000,0.707",
                "observationCamera,9.931,0.386,1.968,0.055,0.767,-0.059,0.637"
            ]
        },
        {
            "time": 1.7829999923706055,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.622,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.681,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.716,0.000,-0.707,0.000,0.707",
                "observationCamera,9.938,0.386,1.965,0.055,0.766,-0.060,0.637"
            ]
        },
        {
            "time": 1.7979999780654908,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.617,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.679,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.714,0.000,-0.707,0.000,0.707",
                "observationCamera,9.945,0.385,1.963,0.055,0.766,-0.060,0.637"
            ]
        },
        {
            "time": 1.8109999895095826,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.613,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.677,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.712,0.000,-0.707,0.000,0.707",
                "observationCamera,9.953,0.385,1.961,0.056,0.766,-0.060,0.638"
            ]
        },
        {
            "time": 1.8209999799728394,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.609,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.676,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.710,0.000,-0.707,0.000,0.707",
                "observationCamera,9.959,0.385,1.959,0.056,0.766,-0.060,0.638"
            ]
        },
        {
            "time": 1.8359999656677247,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.607,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.675,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.708,0.000,-0.707,0.000,0.707",
                "observationCamera,9.964,0.385,1.957,0.056,0.766,-0.060,0.638"
            ]
        },
        {
            "time": 1.850000023841858,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.603,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.673,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.706,0.000,-0.707,0.000,0.707",
                "observationCamera,9.971,0.384,1.955,0.056,0.765,-0.060,0.638"
            ]
        },
        {
            "time": 1.8630000352859498,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.600,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.671,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.705,0.000,-0.707,0.000,0.707",
                "observationCamera,9.978,0.384,1.953,0.056,0.765,-0.061,0.639"
            ]
        },
        {
            "time": 1.8769999742507935,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.597,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.669,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.703,0.000,-0.707,0.000,0.707",
                "observationCamera,9.984,0.384,1.951,0.056,0.765,-0.061,0.639"
            ]
        },
        {
            "time": 1.8930000066757203,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.594,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.668,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.702,0.000,-0.707,0.000,0.707",
                "observationCamera,9.991,0.383,1.949,0.056,0.765,-0.061,0.639"
            ]
        },
        {
            "time": 1.902999997138977,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.591,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.666,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.700,0.000,-0.707,0.000,0.707",
                "observationCamera,9.999,0.383,1.946,0.057,0.764,-0.061,0.639"
            ]
        },
        {
            "time": 1.9170000553131104,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.590,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.664,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.699,0.000,-0.707,0.000,0.707",
                "observationCamera,10.004,0.383,1.945,0.057,0.764,-0.061,0.639"
            ]
        },
        {
            "time": 1.9290000200271607,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.588,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.663,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.698,0.000,-0.707,0.000,0.707",
                "observationCamera,10.011,0.383,1.942,0.057,0.764,-0.061,0.640"
            ]
        },
        {
            "time": 1.944000005722046,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.586,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.661,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.697,0.000,-0.707,0.000,0.707",
                "observationCamera,10.017,0.382,1.940,0.057,0.764,-0.061,0.640"
            ]
        },
        {
            "time": 1.9579999446868897,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.585,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.659,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.696,0.000,-0.707,0.000,0.707",
                "observationCamera,10.025,0.382,1.938,0.057,0.764,-0.062,0.640"
            ]
        },
        {
            "time": 1.9709999561309815,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.584,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.657,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.696,0.000,-0.707,0.000,0.707",
                "observationCamera,10.031,0.382,1.936,0.057,0.764,-0.062,0.640"
            ]
        },
        {
            "time": 1.9839999675750733,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.583,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.656,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.038,0.381,1.934,0.058,0.763,-0.062,0.640"
            ]
        },
        {
            "time": 2.000999927520752,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.654,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.045,0.381,1.932,0.058,0.763,-0.062,0.641"
            ]
        },
        {
            "time": 2.009999990463257,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.652,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.053,0.381,1.929,0.058,0.763,-0.062,0.641"
            ]
        },
        {
            "time": 2.0239999294281008,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.651,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.058,0.381,1.927,0.058,0.763,-0.062,0.641"
            ]
        },
        {
            "time": 2.0360000133514406,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.649,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.065,0.380,1.925,0.058,0.763,-0.063,0.641"
            ]
        },
        {
            "time": 2.052000045776367,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.647,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.071,0.380,1.923,0.058,0.763,-0.063,0.641"
            ]
        },
        {
            "time": 2.062999963760376,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.645,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.079,0.380,1.921,0.059,0.762,-0.063,0.641"
            ]
        },
        {
            "time": 2.0789999961853029,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.644,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.084,0.380,1.919,0.059,0.762,-0.063,0.642"
            ]
        },
        {
            "time": 2.0899999141693117,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.642,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.092,0.379,1.916,0.059,0.762,-0.063,0.642"
            ]
        },
        {
            "time": 2.1080000400543215,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.641,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.098,0.379,1.914,0.059,0.762,-0.063,0.642"
            ]
        },
        {
            "time": 2.118000030517578,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.638,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.107,0.379,1.911,0.059,0.762,-0.064,0.642"
            ]
        },
        {
            "time": 2.13100004196167,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.637,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.112,0.378,1.910,0.059,0.762,-0.064,0.642"
            ]
        },
        {
            "time": 2.1459999084472658,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.635,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.118,0.378,1.908,0.059,0.761,-0.064,0.642"
            ]
        },
        {
            "time": 2.1589999198913576,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.633,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.126,0.378,1.905,0.060,0.761,-0.064,0.643"
            ]
        },
        {
            "time": 2.1730000972747804,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.632,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.132,0.378,1.903,0.060,0.761,-0.064,0.643"
            ]
        },
        {
            "time": 2.186000108718872,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.630,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.139,0.377,1.901,0.060,0.761,-0.064,0.643"
            ]
        },
        {
            "time": 2.1989998817443849,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.629,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.145,0.377,1.899,0.060,0.761,-0.064,0.643"
            ]
        },
        {
            "time": 2.2160000801086427,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.627,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.151,0.377,1.897,0.060,0.761,-0.065,0.643"
            ]
        },
        {
            "time": 2.2260000705718996,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.625,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.160,0.376,1.894,0.060,0.760,-0.065,0.643"
            ]
        },
        {
            "time": 2.240000009536743,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.624,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.164,0.376,1.892,0.060,0.760,-0.065,0.643"
            ]
        },
        {
            "time": 2.252000093460083,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.622,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.171,0.376,1.890,0.061,0.760,-0.065,0.644"
            ]
        },
        {
            "time": 2.265000104904175,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.621,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.177,0.376,1.888,0.061,0.760,-0.065,0.644"
            ]
        },
        {
            "time": 2.2790000438690187,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.619,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.183,0.375,1.886,0.061,0.760,-0.065,0.644"
            ]
        },
        {
            "time": 2.2939999103546144,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.617,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.189,0.375,1.884,0.061,0.760,-0.065,0.644"
            ]
        },
        {
            "time": 2.305999994277954,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.616,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.196,0.375,1.882,0.061,0.760,-0.066,0.644"
            ]
        },
        {
            "time": 2.322000026702881,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.614,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.201,0.375,1.880,0.061,0.759,-0.066,0.644"
            ]
        },
        {
            "time": 2.3329999446868898,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.612,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.209,0.374,1.877,0.062,0.759,-0.066,0.644"
            ]
        },
        {
            "time": 2.3459999561309816,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.611,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.214,0.374,1.875,0.062,0.759,-0.066,0.645"
            ]
        },
        {
            "time": 2.3589999675750734,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.610,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.219,0.374,1.873,0.062,0.759,-0.066,0.645"
            ]
        },
        {
            "time": 2.372999906539917,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.608,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.225,0.374,1.871,0.062,0.759,-0.066,0.645"
            ]
        },
        {
            "time": 2.388000011444092,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.607,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.231,0.373,1.869,0.062,0.759,-0.066,0.645"
            ]
        },
        {
            "time": 2.4000000953674318,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.605,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.238,0.373,1.867,0.062,0.759,-0.067,0.645"
            ]
        },
        {
            "time": 2.4149999618530275,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.604,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.243,0.373,1.865,0.062,0.759,-0.067,0.645"
            ]
        },
        {
            "time": 2.430999994277954,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.602,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.249,0.373,1.863,0.062,0.758,-0.067,0.645"
            ]
        },
        {
            "time": 2.443000078201294,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.600,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.256,0.372,1.861,0.063,0.758,-0.067,0.646"
            ]
        },
        {
            "time": 2.453000068664551,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.599,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.260,0.372,1.859,0.063,0.758,-0.067,0.646"
            ]
        },
        {
            "time": 2.4670000076293947,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.598,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.265,0.372,1.857,0.063,0.758,-0.067,0.646"
            ]
        },
        {
            "time": 2.4800000190734865,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.597,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.270,0.372,1.856,0.063,0.758,-0.067,0.646"
            ]
        },
        {
            "time": 2.493000030517578,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.596,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.275,0.371,1.854,0.063,0.758,-0.067,0.646"
            ]
        },
        {
            "time": 2.507999897003174,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.594,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.280,0.371,1.852,0.063,0.758,-0.068,0.646"
            ]
        },
        {
            "time": 2.5199999809265138,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.593,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.286,0.371,1.850,0.063,0.757,-0.068,0.646"
            ]
        },
        {
            "time": 2.5380001068115236,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.592,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.290,0.371,1.848,0.063,0.757,-0.068,0.646"
            ]
        },
        {
            "time": 2.552000045776367,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.590,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.297,0.371,1.846,0.064,0.757,-0.068,0.647"
            ]
        },
        {
            "time": 2.562000036239624,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.589,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.302,0.370,1.844,0.064,0.757,-0.068,0.647"
            ]
        },
        {
            "time": 2.5739998817443849,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.588,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.305,0.370,1.842,0.064,0.757,-0.068,0.647"
            ]
        },
        {
            "time": 2.5889999866485597,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.587,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.309,0.370,1.841,0.064,0.757,-0.068,0.647"
            ]
        },
        {
            "time": 2.6029999256134035,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.586,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.314,0.370,1.839,0.064,0.757,-0.068,0.647"
            ]
        },
        {
            "time": 2.614000082015991,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.584,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.319,0.370,1.837,0.064,0.757,-0.068,0.647"
            ]
        },
        {
            "time": 2.627000093460083,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.584,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.322,0.369,1.836,0.064,0.756,-0.068,0.647"
            ]
        },
        {
            "time": 2.6449999809265138,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.583,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.326,0.369,1.834,0.064,0.756,-0.069,0.647"
            ]
        },
        {
            "time": 2.6579999923706056,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.581,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.332,0.369,1.832,0.064,0.756,-0.069,0.648"
            ]
        },
        {
            "time": 2.6689999103546144,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.580,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.335,0.369,1.830,0.064,0.756,-0.069,0.648"
            ]
        },
        {
            "time": 2.681999921798706,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.579,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.338,0.369,1.829,0.065,0.756,-0.069,0.648"
            ]
        },
        {
            "time": 2.696000099182129,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.579,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.342,0.369,1.828,0.065,0.756,-0.069,0.648"
            ]
        },
        {
            "time": 2.7070000171661379,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.578,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.346,0.368,1.826,0.065,0.756,-0.069,0.648"
            ]
        },
        {
            "time": 2.7209999561309816,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.577,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.348,0.368,1.825,0.065,0.756,-0.069,0.648"
            ]
        },
        {
            "time": 2.736999988555908,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.576,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.352,0.368,1.823,0.065,0.755,-0.069,0.648"
            ]
        },
        {
            "time": 2.75,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.575,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.356,0.368,1.822,0.065,0.755,-0.069,0.648"
            ]
        },
        {
            "time": 2.763000011444092,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.574,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.359,0.368,1.820,0.065,0.755,-0.069,0.649"
            ]
        },
        {
            "time": 2.7760000228881838,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.574,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.361,0.368,1.819,0.065,0.755,-0.069,0.649"
            ]
        },
        {
            "time": 2.7880001068115236,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.573,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.364,0.368,1.818,0.065,0.755,-0.069,0.649"
            ]
        },
        {
            "time": 2.8010001182556154,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.572,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.366,0.368,1.816,0.065,0.755,-0.069,0.649"
            ]
        },
        {
            "time": 2.815999984741211,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.572,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.369,0.367,1.815,0.065,0.755,-0.069,0.649"
            ]
        },
        {
            "time": 2.8289999961853029,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.571,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.371,0.367,1.814,0.065,0.755,-0.069,0.649"
            ]
        },
        {
            "time": 2.8410000801086427,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.571,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.374,0.367,1.813,0.065,0.754,-0.070,0.649"
            ]
        },
        {
            "time": 2.8559999465942385,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.570,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.375,0.367,1.812,0.066,0.754,-0.070,0.650"
            ]
        },
        {
            "time": 2.871999979019165,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.570,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.377,0.367,1.810,0.066,0.754,-0.070,0.650"
            ]
        },
        {
            "time": 2.881999969482422,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.569,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.380,0.367,1.809,0.066,0.754,-0.070,0.650"
            ]
        },
        {
            "time": 2.8949999809265138,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.569,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.381,0.367,1.808,0.066,0.754,-0.070,0.650"
            ]
        },
        {
            "time": 2.9070000648498537,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.568,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.382,0.367,1.807,0.066,0.754,-0.070,0.650"
            ]
        },
        {
            "time": 2.9210000038146974,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.568,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.383,0.367,1.806,0.066,0.754,-0.070,0.650"
            ]
        },
        {
            "time": 2.934000015258789,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.568,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.384,0.367,1.806,0.066,0.753,-0.070,0.651"
            ]
        },
        {
            "time": 2.9489998817443849,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.568,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.385,0.367,1.805,0.066,0.753,-0.070,0.651"
            ]
        },
        {
            "time": 2.9630000591278078,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.386,0.367,1.804,0.066,0.753,-0.070,0.651"
            ]
        },
        {
            "time": 2.9790000915527345,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.387,0.367,1.803,0.066,0.753,-0.070,0.651"
            ]
        },
        {
            "time": 2.989000082015991,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.387,0.367,1.802,0.066,0.753,-0.070,0.651"
            ]
        },
        {
            "time": 3.002000093460083,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.387,0.367,1.802,0.066,0.753,-0.070,0.651"
            ]
        },
        {
            "time": 3.0139999389648439,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.387,0.367,1.801,0.066,0.753,-0.070,0.652"
            ]
        },
        {
            "time": 3.0269999504089357,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.730,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.387,0.367,1.800,0.066,0.752,-0.070,0.652"
            ]
        },
        {
            "time": 3.0409998893737795,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.729,0.000,1.582,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.387,0.367,1.800,0.066,0.752,-0.070,0.652"
            ]
        },
        {
            "time": 3.053999900817871,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.729,0.000,1.583,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.386,0.367,1.799,0.066,0.752,-0.070,0.652"
            ]
        },
        {
            "time": 3.072000026702881,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.728,0.000,1.583,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.385,0.367,1.798,0.066,0.752,-0.070,0.652"
            ]
        },
        {
            "time": 3.0810000896453859,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.726,0.000,1.584,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.384,0.367,1.798,0.066,0.752,-0.069,0.652"
            ]
        },
        {
            "time": 3.0959999561309816,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.725,0.000,1.585,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.382,0.367,1.797,0.066,0.752,-0.069,0.653"
            ]
        },
        {
            "time": 3.1070001125335695,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.723,0.000,1.586,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.381,0.367,1.796,0.066,0.751,-0.069,0.653"
            ]
        },
        {
            "time": 3.121999979019165,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.721,0.000,1.587,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.379,0.367,1.796,0.066,0.751,-0.069,0.653"
            ]
        },
        {
            "time": 3.135999917984009,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.719,0.000,1.589,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.376,0.367,1.795,0.066,0.751,-0.069,0.653"
            ]
        },
        {
            "time": 3.1489999294281008,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.716,0.000,1.590,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.374,0.367,1.795,0.066,0.751,-0.069,0.653"
            ]
        },
        {
            "time": 3.1619999408721926,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.713,0.000,1.592,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.371,0.367,1.794,0.066,0.751,-0.069,0.654"
            ]
        },
        {
            "time": 3.1760001182556154,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.711,0.000,1.594,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.368,0.368,1.793,0.066,0.751,-0.069,0.654"
            ]
        },
        {
            "time": 3.187999963760376,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.707,0.000,1.596,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.365,0.368,1.793,0.066,0.751,-0.069,0.654"
            ]
        },
        {
            "time": 3.200000047683716,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.704,0.000,1.597,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.362,0.368,1.792,0.066,0.750,-0.069,0.654"
            ]
        },
        {
            "time": 3.2139999866485597,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.701,0.000,1.599,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.359,0.368,1.792,0.065,0.750,-0.069,0.654"
            ]
        },
        {
            "time": 3.2269999980926515,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.698,0.000,1.602,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.355,0.368,1.791,0.065,0.750,-0.069,0.654"
            ]
        },
        {
            "time": 3.242000102996826,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.694,0.000,1.604,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.351,0.368,1.791,0.065,0.750,-0.068,0.655"
            ]
        },
        {
            "time": 3.25600004196167,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.689,0.000,1.607,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.346,0.369,1.790,0.065,0.750,-0.068,0.655"
            ]
        },
        {
            "time": 3.2690000534057619,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.685,0.000,1.609,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.341,0.369,1.789,0.065,0.750,-0.068,0.655"
            ]
        },
        {
            "time": 3.2850000858306886,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.681,0.000,1.612,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.337,0.369,1.789,0.065,0.750,-0.068,0.655"
            ]
        },
        {
            "time": 3.2960000038146974,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.676,0.000,1.615,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.331,0.369,1.788,0.065,0.750,-0.068,0.655"
            ]
        },
        {
            "time": 3.306999921798706,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.672,0.000,1.617,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.327,0.370,1.788,0.065,0.749,-0.068,0.655"
            ]
        },
        {
            "time": 3.322000026702881,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.668,0.000,1.620,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.322,0.370,1.787,0.065,0.749,-0.067,0.656"
            ]
        },
        {
            "time": 3.3329999446868898,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.663,0.000,1.623,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.316,0.370,1.787,0.064,0.749,-0.067,0.656"
            ]
        },
        {
            "time": 3.3489999771118166,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.658,0.000,1.625,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.311,0.370,1.786,0.064,0.749,-0.067,0.656"
            ]
        },
        {
            "time": 3.359999895095825,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.652,0.000,1.629,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.305,0.371,1.786,0.064,0.749,-0.067,0.656"
            ]
        },
        {
            "time": 3.372999906539917,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.648,0.000,1.631,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.300,0.371,1.785,0.064,0.749,-0.067,0.656"
            ]
        },
        {
            "time": 3.3919999599456789,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.643,0.000,1.634,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.294,0.371,1.785,0.064,0.749,-0.067,0.656"
            ]
        },
        {
            "time": 3.4040000438690187,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.636,0.000,1.639,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.285,0.372,1.784,0.064,0.749,-0.066,0.657"
            ]
        },
        {
            "time": 3.4140000343322756,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.631,0.000,1.642,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.279,0.372,1.783,0.064,0.748,-0.066,0.657"
            ]
        },
        {
            "time": 3.428999900817871,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.627,0.000,1.644,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.274,0.372,1.783,0.064,0.748,-0.066,0.657"
            ]
        },
        {
            "time": 3.441999912261963,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.621,0.000,1.648,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.266,0.373,1.782,0.063,0.748,-0.066,0.657"
            ]
        },
        {
            "time": 3.4560000896453859,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.616,0.000,1.651,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.259,0.373,1.782,0.063,0.748,-0.066,0.657"
            ]
        },
        {
            "time": 3.4690001010894777,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.610,0.000,1.654,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.252,0.373,1.781,0.063,0.748,-0.065,0.657"
            ]
        },
        {
            "time": 3.4809999465942385,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.605,0.000,1.658,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.245,0.374,1.781,0.063,0.748,-0.065,0.658"
            ]
        },
        {
            "time": 3.497999906539917,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.600,0.000,1.661,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.238,0.374,1.781,0.063,0.748,-0.065,0.658"
            ]
        },
        {
            "time": 3.509999990463257,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.593,0.000,1.665,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.228,0.374,1.780,0.062,0.748,-0.065,0.658"
            ]
        },
        {
            "time": 3.5209999084472658,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.588,0.000,1.668,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.221,0.375,1.779,0.062,0.748,-0.064,0.658"
            ]
        },
        {
            "time": 3.5360000133514406,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.583,0.000,1.671,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.215,0.375,1.779,0.062,0.747,-0.064,0.658"
            ]
        },
        {
            "time": 3.5480000972747804,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.577,0.000,1.674,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.206,0.376,1.779,0.062,0.747,-0.064,0.658"
            ]
        },
        {
            "time": 3.561000108718872,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.572,0.000,1.677,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.199,0.376,1.778,0.062,0.747,-0.064,0.659"
            ]
        },
        {
            "time": 3.5739998817443849,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.567,0.000,1.681,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.191,0.376,1.778,0.062,0.747,-0.063,0.659"
            ]
        },
        {
            "time": 3.5869998931884767,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.562,0.000,1.684,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.183,0.377,1.777,0.061,0.747,-0.063,0.659"
            ]
        },
        {
            "time": 3.6050000190734865,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.556,0.000,1.687,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.174,0.377,1.777,0.061,0.747,-0.063,0.659"
            ]
        },
        {
            "time": 3.615999937057495,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.549,0.000,1.691,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.163,0.378,1.776,0.061,0.747,-0.063,0.659"
            ]
        },
        {
            "time": 3.630000114440918,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.545,0.000,1.694,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.156,0.378,1.776,0.061,0.747,-0.062,0.659"
            ]
        },
        {
            "time": 3.6410000324249269,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.539,0.000,1.697,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.146,0.378,1.775,0.060,0.747,-0.062,0.660"
            ]
        },
        {
            "time": 3.6549999713897707,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.535,0.000,1.700,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.139,0.379,1.775,0.060,0.746,-0.062,0.660"
            ]
        },
        {
            "time": 3.6679999828338625,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.530,0.000,1.703,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.130,0.379,1.775,0.060,0.746,-0.062,0.660"
            ]
        },
        {
            "time": 3.681999921798706,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.525,0.000,1.706,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.121,0.380,1.774,0.060,0.746,-0.061,0.660"
            ]
        },
        {
            "time": 3.697000026702881,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.520,0.000,1.709,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.111,0.380,1.774,0.060,0.746,-0.061,0.660"
            ]
        },
        {
            "time": 3.7109999656677248,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.515,0.000,1.712,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.101,0.381,1.773,0.059,0.746,-0.061,0.660"
            ]
        },
        {
            "time": 3.7269999980926515,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.510,0.000,1.715,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.091,0.381,1.773,0.059,0.746,-0.060,0.661"
            ]
        },
        {
            "time": 3.7360000610351564,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.505,0.000,1.718,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.080,0.382,1.772,0.059,0.746,-0.060,0.661"
            ]
        },
        {
            "time": 3.750999927520752,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.502,0.000,1.720,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.073,0.382,1.772,0.059,0.746,-0.060,0.661"
            ]
        },
        {
            "time": 3.7639999389648439,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.497,0.000,1.723,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.063,0.382,1.771,0.058,0.746,-0.060,0.661"
            ]
        },
        {
            "time": 3.7780001163482668,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.493,0.000,1.726,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.053,0.383,1.771,0.058,0.746,-0.059,0.661"
            ]
        },
        {
            "time": 3.7909998893737795,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.489,0.000,1.728,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.043,0.383,1.771,0.058,0.746,-0.059,0.661"
            ]
        },
        {
            "time": 3.802999973297119,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.485,0.000,1.730,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.033,0.384,1.770,0.058,0.745,-0.059,0.661"
            ]
        },
        {
            "time": 3.818000078201294,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.482,0.000,1.732,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.025,0.384,1.770,0.057,0.745,-0.058,0.662"
            ]
        },
        {
            "time": 3.8310000896453859,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.478,0.000,1.734,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.013,0.385,1.770,0.057,0.745,-0.058,0.662"
            ]
        },
        {
            "time": 3.8450000286102297,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.475,0.000,1.736,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,10.004,0.385,1.769,0.057,0.745,-0.058,0.662"
            ]
        },
        {
            "time": 3.8589999675750734,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.472,0.000,1.738,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.993,0.386,1.769,0.057,0.745,-0.058,0.662"
            ]
        },
        {
            "time": 3.871999979019165,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.469,0.000,1.740,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.983,0.386,1.768,0.056,0.745,-0.057,0.662"
            ]
        },
        {
            "time": 3.884999990463257,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.466,0.000,1.742,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.973,0.387,1.768,0.056,0.745,-0.057,0.662"
            ]
        },
        {
            "time": 3.8970000743865969,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.464,0.000,1.743,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.963,0.387,1.768,0.056,0.745,-0.057,0.662"
            ]
        },
        {
            "time": 3.9110000133514406,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.462,0.000,1.744,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.954,0.388,1.767,0.056,0.745,-0.056,0.663"
            ]
        },
        {
            "time": 3.928999900817871,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.460,0.000,1.745,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.943,0.388,1.767,0.055,0.745,-0.056,0.663"
            ]
        },
        {
            "time": 3.943000078201294,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.458,0.000,1.747,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.929,0.389,1.767,0.055,0.745,-0.056,0.663"
            ]
        },
        {
            "time": 3.9509999752044679,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.457,0.000,1.747,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.919,0.389,1.766,0.055,0.744,-0.055,0.663"
            ]
        },
        {
            "time": 3.9660000801086427,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.456,0.000,1.748,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.912,0.390,1.766,0.055,0.744,-0.055,0.663"
            ]
        },
        {
            "time": 3.9779999256134035,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.455,0.000,1.748,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.901,0.390,1.766,0.054,0.744,-0.055,0.663"
            ]
        },
        {
            "time": 3.992000102996826,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.892,0.391,1.765,0.054,0.744,-0.055,0.663"
            ]
        },
        {
            "time": 4.006999969482422,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.881,0.391,1.765,0.054,0.744,-0.054,0.664"
            ]
        },
        {
            "time": 4.020999908447266,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.869,0.392,1.765,0.054,0.744,-0.054,0.664"
            ]
        },
        {
            "time": 4.0370001792907719,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.439,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.859,0.392,1.764,0.053,0.744,-0.054,0.664"
            ]
        },
        {
            "time": 4.046999931335449,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.438,0.000,1.917,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.847,0.393,1.764,0.053,0.744,-0.053,0.664"
            ]
        },
        {
            "time": 4.061999797821045,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.437,0.000,1.916,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.839,0.393,1.764,0.053,0.744,-0.053,0.664"
            ]
        },
        {
            "time": 4.072999954223633,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.436,0.000,1.916,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.828,0.394,1.763,0.053,0.744,-0.053,0.664"
            ]
        },
        {
            "time": 4.089000225067139,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.435,0.000,1.916,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.819,0.394,1.763,0.052,0.744,-0.052,0.664"
            ]
        },
        {
            "time": 4.1020002365112309,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.433,0.000,1.915,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.807,0.395,1.763,0.052,0.744,-0.052,0.664"
            ]
        },
        {
            "time": 4.113999843597412,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.431,0.000,1.915,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.797,0.395,1.762,0.052,0.744,-0.052,0.665"
            ]
        },
        {
            "time": 4.129000186920166,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.429,0.000,1.914,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.788,0.396,1.762,0.052,0.744,-0.051,0.665"
            ]
        },
        {
            "time": 4.144000053405762,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.426,0.000,1.913,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.776,0.396,1.762,0.051,0.743,-0.051,0.665"
            ]
        },
        {
            "time": 4.15500020980835,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.423,0.000,1.912,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.765,0.397,1.762,0.051,0.743,-0.051,0.665"
            ]
        },
        {
            "time": 4.169000148773193,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.421,0.000,1.911,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.757,0.397,1.761,0.051,0.743,-0.051,0.665"
            ]
        },
        {
            "time": 4.183000087738037,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.417,0.000,1.910,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.746,0.398,1.761,0.051,0.743,-0.050,0.665"
            ]
        },
        {
            "time": 4.197000026702881,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.414,0.000,1.909,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.736,0.398,1.761,0.050,0.743,-0.050,0.665"
            ]
        },
        {
            "time": 4.210000038146973,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.410,0.000,1.908,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.726,0.399,1.760,0.050,0.743,-0.050,0.665"
            ]
        },
        {
            "time": 4.2220001220703129,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.407,0.000,1.907,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.716,0.399,1.760,0.050,0.743,-0.049,0.666"
            ]
        },
        {
            "time": 4.236000061035156,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.403,0.000,1.906,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.707,0.400,1.760,0.050,0.743,-0.049,0.666"
            ]
        },
        {
            "time": 4.254000186920166,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.399,0.000,1.905,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.697,0.400,1.760,0.049,0.743,-0.049,0.666"
            ]
        },
        {
            "time": 4.263999938964844,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.393,0.000,1.903,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.684,0.401,1.759,0.049,0.743,-0.048,0.666"
            ]
        },
        {
            "time": 4.2779998779296879,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.390,0.000,1.902,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.677,0.401,1.759,0.049,0.743,-0.048,0.666"
            ]
        },
        {
            "time": 4.290999889373779,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.385,0.000,1.901,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.667,0.402,1.759,0.049,0.743,-0.048,0.666"
            ]
        },
        {
            "time": 4.304999828338623,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.380,0.000,1.899,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.657,0.402,1.759,0.048,0.743,-0.048,0.666"
            ]
        },
        {
            "time": 4.317999839782715,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.376,0.000,1.898,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.648,0.403,1.758,0.048,0.743,-0.047,0.666"
            ]
        },
        {
            "time": 4.329999923706055,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.371,0.000,1.896,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.639,0.403,1.758,0.048,0.743,-0.047,0.666"
            ]
        },
        {
            "time": 4.3460001945495609,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.366,0.000,1.895,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.630,0.403,1.758,0.048,0.743,-0.047,0.666"
            ]
        },
        {
            "time": 4.361999988555908,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.360,0.000,1.893,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.620,0.404,1.758,0.047,0.743,-0.047,0.667"
            ]
        },
        {
            "time": 4.375,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.354,0.000,1.891,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.609,0.405,1.758,0.047,0.742,-0.046,0.667"
            ]
        },
        {
            "time": 4.38700008392334,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.349,0.000,1.890,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.600,0.405,1.757,0.047,0.742,-0.046,0.667"
            ]
        },
        {
            "time": 4.3979997634887699,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.344,0.000,1.888,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.593,0.405,1.757,0.047,0.742,-0.046,0.667"
            ]
        },
        {
            "time": 4.413000106811523,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.339,0.000,1.887,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.585,0.406,1.757,0.047,0.742,-0.046,0.667"
            ]
        },
        {
            "time": 4.427000045776367,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.333,0.000,1.885,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.575,0.406,1.757,0.046,0.742,-0.045,0.667"
            ]
        },
        {
            "time": 4.439000129699707,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.327,0.000,1.883,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.567,0.407,1.757,0.046,0.742,-0.045,0.667"
            ]
        },
        {
            "time": 4.453999996185303,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.323,0.000,1.882,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.559,0.407,1.756,0.046,0.742,-0.045,0.667"
            ]
        },
        {
            "time": 4.468999862670898,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.316,0.000,1.880,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.550,0.407,1.756,0.046,0.742,-0.045,0.667"
            ]
        },
        {
            "time": 4.480999946594238,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.310,0.000,1.878,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.541,0.408,1.756,0.045,0.742,-0.044,0.667"
            ]
        },
        {
            "time": 4.493000030517578,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.305,0.000,1.877,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.534,0.408,1.756,0.045,0.742,-0.044,0.667"
            ]
        },
        {
            "time": 4.50600004196167,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.300,0.000,1.875,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.527,0.409,1.756,0.045,0.742,-0.044,0.667"
            ]
        },
        {
            "time": 4.521999835968018,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.294,0.000,1.873,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.519,0.409,1.756,0.045,0.742,-0.044,0.668"
            ]
        },
        {
            "time": 4.535999774932861,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.287,0.000,1.871,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.510,0.409,1.755,0.045,0.742,-0.043,0.668"
            ]
        },
        {
            "time": 4.548999786376953,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.281,0.000,1.869,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.503,0.410,1.755,0.044,0.742,-0.043,0.668"
            ]
        },
        {
            "time": 4.563000202178955,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.276,0.000,1.868,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.495,0.410,1.755,0.044,0.742,-0.043,0.668"
            ]
        },
        {
            "time": 4.578999996185303,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.270,0.000,1.866,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.488,0.410,1.755,0.044,0.742,-0.043,0.668"
            ]
        },
        {
            "time": 4.593999862670898,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.263,0.000,1.864,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.480,0.411,1.755,0.044,0.742,-0.042,0.668"
            ]
        },
        {
            "time": 4.6020002365112309,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.257,0.000,1.862,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.472,0.411,1.755,0.044,0.742,-0.042,0.668"
            ]
        },
        {
            "time": 4.616000175476074,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.253,0.000,1.861,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.468,0.411,1.755,0.044,0.742,-0.042,0.668"
            ]
        },
        {
            "time": 4.63100004196167,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.248,0.000,1.859,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.462,0.412,1.754,0.043,0.742,-0.042,0.668"
            ]
        },
        {
            "time": 4.64300012588501,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.242,0.000,1.857,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.454,0.412,1.754,0.043,0.742,-0.042,0.668"
            ]
        },
        {
            "time": 4.6579999923706059,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.237,0.000,1.856,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.449,0.412,1.754,0.043,0.742,-0.042,0.668"
            ]
        },
        {
            "time": 4.670000076293945,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.231,0.000,1.854,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.442,0.413,1.754,0.043,0.742,-0.041,0.668"
            ]
        },
        {
            "time": 4.685999870300293,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.227,0.000,1.853,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.437,0.413,1.754,0.043,0.742,-0.041,0.668"
            ]
        },
        {
            "time": 4.698999881744385,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.221,0.000,1.851,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.431,0.413,1.754,0.043,0.742,-0.041,0.668"
            ]
        },
        {
            "time": 4.710999965667725,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.216,0.000,1.850,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.425,0.413,1.754,0.042,0.742,-0.041,0.668"
            ]
        },
        {
            "time": 4.72599983215332,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.212,0.000,1.848,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.421,0.414,1.754,0.042,0.741,-0.041,0.668"
            ]
        },
        {
            "time": 4.73799991607666,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.206,0.000,1.847,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.415,0.414,1.754,0.042,0.741,-0.041,0.668"
            ]
        },
        {
            "time": 4.751999855041504,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.202,0.000,1.846,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.411,0.414,1.753,0.042,0.741,-0.040,0.668"
            ]
        },
        {
            "time": 4.764999866485596,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.198,0.000,1.844,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.406,0.414,1.753,0.042,0.741,-0.040,0.669"
            ]
        },
        {
            "time": 4.7789998054504398,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.194,0.000,1.843,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.402,0.415,1.753,0.042,0.741,-0.040,0.669"
            ]
        },
        {
            "time": 4.795000076293945,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.190,0.000,1.842,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.397,0.415,1.753,0.042,0.741,-0.040,0.669"
            ]
        },
        {
            "time": 4.809000015258789,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.185,0.000,1.840,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.393,0.415,1.753,0.042,0.741,-0.040,0.669"
            ]
        },
        {
            "time": 4.820000171661377,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.181,0.000,1.839,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.389,0.415,1.753,0.042,0.741,-0.040,0.669"
            ]
        },
        {
            "time": 4.835000038146973,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.178,0.000,1.838,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.386,0.415,1.753,0.041,0.741,-0.040,0.669"
            ]
        },
        {
            "time": 4.848999977111816,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.175,0.000,1.837,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.382,0.416,1.753,0.041,0.741,-0.040,0.669"
            ]
        },
        {
            "time": 4.86299991607666,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.172,0.000,1.836,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.379,0.416,1.753,0.041,0.741,-0.040,0.669"
            ]
        },
        {
            "time": 4.874000072479248,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.169,0.000,1.835,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.376,0.416,1.753,0.041,0.741,-0.039,0.669"
            ]
        },
        {
            "time": 4.888000011444092,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.166,0.000,1.835,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.374,0.416,1.753,0.041,0.741,-0.039,0.669"
            ]
        },
        {
            "time": 4.9070000648498539,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.164,0.000,1.834,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.372,0.416,1.753,0.041,0.741,-0.039,0.669"
            ]
        },
        {
            "time": 4.918000221252441,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.161,0.000,1.833,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.369,0.416,1.753,0.041,0.741,-0.039,0.669"
            ]
        },
        {
            "time": 4.931000232696533,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.159,0.000,1.833,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.368,0.416,1.753,0.041,0.741,-0.039,0.669"
            ]
        },
        {
            "time": 4.945000171661377,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.158,0.000,1.832,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.366,0.416,1.753,0.041,0.741,-0.039,0.669"
            ]
        },
        {
            "time": 4.955999851226807,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.157,0.000,1.832,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.365,0.416,1.753,0.041,0.741,-0.039,0.669"
            ]
        },
        {
            "time": 4.96999979019165,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.156,0.000,1.831,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.364,0.416,1.753,0.041,0.741,-0.039,0.669"
            ]
        },
        {
            "time": 4.986000061035156,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.155,0.000,1.831,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.363,0.416,1.753,0.041,0.741,-0.039,0.669"
            ]
        },
        {
            "time": 4.999000072479248,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.154,0.000,1.831,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.363,0.416,1.753,0.041,0.741,-0.039,0.669"
            ]
        },
        {
            "time": 5.014999866485596,
            "data": [
                "police5,10.837,0.000,1.350,0.000,-0.707,0.000,-0.707",
                "police6,10.860,0.000,2.008,0.000,-0.795,0.000,-0.606",
                "citizenM2,11.454,0.000,1.749,0.000,-0.707,0.000,0.707",
                "citizenM3,11.827,0.000,1.291,0.000,-0.707,0.000,0.707",
                "citizenF2,11.154,0.000,1.831,0.000,-0.707,0.000,0.707",
                "citizenF3,11.516,0.000,1.567,0.000,-0.707,0.000,0.707",
                "cordon,11.047,0.020,1.607,-0.024,-0.706,0.017,-0.707",
                "reporter1,11.179,0.000,1.439,0.000,-0.707,0.000,0.707",
                "reporter2,11.148,0.000,1.695,0.000,-0.707,0.000,0.707",
                "observationCamera,9.363,0.416,1.753,0.041,0.741,-0.039,0.669"
            ]
        }
    ]
};